<div class="modal fade" [id]="modalId" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header align-items-center">
        <h1 class="modal-title mt-0 ml-4" id="exampleModalLabel">{{ titulo }}</h1>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="CERRAR" alt="CERRAR">
          <div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
        </button>
      </div>

      <div class="modal-body">
        <div class="row align-items-center my-3 mx-4">
          <p class="mb-0 ml-0" [innerHtml]="texto"></p>
        </div>
      </div>
      
      <div class="modal-footer justify-content-center">
        <div class="my-4">
          <button [id]="modalId+'-close'" class="boton-secundario boton_secundario_modal ml-3" data-toggle="tooltip" data-placement="top" title="Cerrar" alt="Cerrar" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</div>